export const typeShortNameMap = {
  0: '',
  1: 'дом',
  2: 'подъезд',
  3: 'кв.',
  4: 'уч.',
  5: 'клад.',
  6: 'прк.',
  7: 'оф.',
  8: 'нежилое',
  10: 'таунхаус',
  11: 'пом',
  12: 'апартам.',
  13: 'комната',
  14: 'мм',
  17: 'вилла',
  18: 'сейф',
};
